export const preloadFonts = () => {

  if (typeof document === 'undefined') return;

  // Utility function to load a font
  const loadFont = async (
    family: string,
    url: string,
    options: Partial<FontFaceDescriptors>
  ) => {
    const font = new FontFace(family, `url(${url})`, options);
    const loadedFont = await font.load();
    document.fonts.add(loadedFont);
    return loadedFont;
  }

  // Load all variants of Maison Neue
  Promise.all([
    loadFont("Maison Neue", "/fonts/maisonneuebook.ttf", {
      weight: "normal",
      style: "normal",
    }),
    loadFont("Maison Neue", "/fonts/maisonneuebookitalic.ttf", {
      weight: "normal",
      style: "italic",
    }),
    loadFont("Maison Neue", "/fonts/maisonneuebold.ttf", {
      weight: "bold",
      style: "normal",
    }),
    loadFont("Maison Neue", "/fonts/maisonneuebolditalic.ttf", {
      weight: "bold",
      style: "italic",
    }),
    loadFont("Maison Neue", "/fonts/MaisonNeueDemi.ttf", {
      weight: "600",
      style: "normal",
    }),
  ])
}